import { Component, OnDestroy, OnInit, TemplateRef, ChangeDetectionStrategy, inject, output, viewChild, input } from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '@environments/environment';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {VariableScope} from '@app/services/variable.service';
import { IframeModalShellComponent } from '../iframe-modal-shell/iframe-modal-shell.component';

@Component({
  selector: 'app-variables',
  templateUrl: './variables.component.html',
  styleUrls: ['./variables.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IframeModalShellComponent]
})
export class VariablesComponent implements OnInit, OnDestroy {
  private _modalService = inject(NgbModal);
  private sanitizer = inject(DomSanitizer);


  // eslint-disable-next-line @angular-eslint/no-output-on-prefix -- renaming the output would change every binding to it
  public readonly onVariableForClick = output<any>();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix -- renaming the output would change every binding to it
  public readonly onVariableClick = output<any>();
  readonly variableClickFor = input<string>(undefined);
  readonly fieldType = input('text');
  readonly format = input('plain_text');
  readonly isDisabled = input(false);
  readonly hideText = input(true);
  readonly variables = input<any>(undefined);
  /** 'systemic': the picker lists only the system variables (a system email's field). */
  readonly variableScope = input<VariableScope>('campaign');
  readonly variablesList = viewChild<TemplateRef<any>>('variablesList');
  sharevariableListUrl: any = '';
  variableListUrl: SafeResourceUrl;
  private readonly messageHandler = (event: MessageEvent) => this.receiveMessage(event);
  /** The picker this component opened: picking closes it, never a popup the field sits in. */
  private pickerRef: NgbModalRef | null = null;

  ngOnInit(): void {
    window.addEventListener('message', this.messageHandler, false);
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.messageHandler, false);
  }

  receiveMessage(event: MessageEvent): void {
    if (!event.data || typeof event.data !== 'object') {
      return;
    }
    if (event.data.type === 'variable' && event.data.target === this.variableClickFor()) {
      this.handleUserData(event.data.data);
    }
  }

  handleUserData(variable: any): void {
    this.onClickVariable(variable);
    // this.cdr.detectChanges();
  }

  onAddVariablesButtonClick(variablesList) {
    const pagePath = window.location.pathname + window.location.search + window.location.hash;
    const theme = document.body.classList.contains('dark-theme') ? 'dark' : 'light';
    this.sharevariableListUrl = environment.frontUrl.replace('/#', '').replace(/\/+$/, '') + `/b/variable/template?type=variable&target=${this.variableClickFor()}&field_name=${encodeURIComponent(this.variableClickFor())}&field_type=${encodeURIComponent(this.fieldType() || 'text')}&format=${encodeURIComponent(this.format() || 'plain_text')}&page_path=${encodeURIComponent(pagePath)}&theme=${encodeURIComponent(theme)}`;
    if (this.variableScope() === 'systemic') {
      // No token: the picker only reads it to log a variable's use.
      this.sharevariableListUrl += `&appcontext=${encodeURIComponent(JSON.stringify({systemic: true}))}`;
    }
    this.variableListUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.sharevariableListUrl);

    const modelRef = this.pickerRef = this._modalService.open(variablesList, {
      centered: false,
      size: 'xl',
      keyboard: true,
      windowClass: 'snoball-iframe-modal-window snoball-browser-modal',
      backdropClass: 'snoball-browser-modal-backdrop',
    });
    const closed = () => {
      if (this.pickerRef === modelRef) {
        this.pickerRef = null;
      }
    };
    modelRef.result.then(closed, closed);
    this.onVariableForClick.emit(this.variableClickFor());
  }

  onClickVariable(variable): void {
    this.onVariableClick.emit(variable);
    this.pickerRef?.close();
    this.pickerRef = null;
  }
}
